<template>
  <div class="work-detail-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="flex justify-between">
          <div class="text-title">{{ $t("workDetail.title") }}</div>
          <div>
            <el-button type="primary" size="small" @click="goBack">
              <i class="el-icon-close"></i>{{ $t("common.back") }}
            </el-button>
          </div>
        </div>
      </div>

      <!-- 业主信息 -->
      <div class="margin-top">
        <el-row :gutter="20">
          <el-col :span="24" class="text-left">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.workId") }}:
                  </label>
                  <label>{{ workDetailInfo.workId }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.workName") }}:
                  </label>
                  <label>{{ workDetailInfo.workName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.typeName") }}:
                  </label>
                  <label>{{ workDetailInfo.typeName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.workCycle") }}:
                  </label>
                  <label>{{
                    workDetailInfo.workCycle == "1001"
                      ? $t("workDetail.once")
                      : $t("workDetail.periodic")
                  }}</label>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.startTime") }}:
                  </label>
                  <label>{{ workDetailInfo.startTime }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.endTime") }}:
                  </label>
                  <label>{{ workDetailInfo.endTime }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.createUserName") }}:
                  </label>
                  <label>{{ workDetailInfo.createUserName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.curStaffName") }}:
                  </label>
                  <label>{{ workDetailInfo.curStaffName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.curCopyName") }}:
                  </label>
                  <label>{{ workDetailInfo.curCopyName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.stateName") }}:
                  </label>
                  <label>{{ workDetailInfo.stateName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">
                    {{ $t("workDetail.createTime") }}:
                  </label>
                  <label>{{ workDetailInfo.createTime }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group flex justify-start">
                  <label class="col-form-label">
                    {{ $t("workDetail.attachment") }}:
                  </label>
                  <div class="flex justify-start">
                    <!-- 使用计算属性，仅循环有效链接 -->
                    <div
                      v-for="(url, index) in standardPathUrls"
                      :key="index"
                      class="mr-2"
                    >
                      <div v-if="url.endsWith('jpg') || url.endsWith('png')">
                        <img
                          style="width: 60px; height: 60px"
                          class="border-radius"
                          :src="url"
                          @click="viewTaskFileImg(url)"
                        />
                      </div>
                      <div v-else>
                        <a :href="url" target="_blank">{{
                          $t("common.download")
                        }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="info-item">
                  <label>{{ $t("workDetail.logType") }}:</label>
                  <span>{{ workDetailInfo.logType }}</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <divider></divider>

      <div class="margin-top-sm">
        <el-tabs
          v-model="workDetailInfo._currentTab"
          @tab-click="changeTab(workDetailInfo._currentTab)"
        >
          <el-tab-pane
            :label="$t('workDetail.content')"
            name="workDetailContent"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('workDetail.handler')"
            name="workDetailTask"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('workDetail.handlerContent')"
            name="workDetailTaskItem"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('workDetail.copyPerson')"
            name="workDetailCopy"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('workDetail.workFlow')"
            name="workDetailEvent"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('workDetail.flowAttachment')"
            name="workDetailFile"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('workDetail.workType')"
            name="workDetailType"
          ></el-tab-pane>
          <el-tab-pane
            v-if="workDetailInfo.workCycle == '2002'"
            :label="$t('workDetail.workCycle')"
            name="workDetailCycle"
          ></el-tab-pane>
        </el-tabs>
      </div>

      <!-- 修复：显示基于wtId字典值的任务类型 + 工作内容 -->
      <div v-if="workDetailInfo._currentTab == 'workDetailContent'">
        <div
          class="padding"
          v-for="(item, index) in workDetailInfo.contents"
          :key="index"
        >
          <!-- <div class="text-left">
            任务类型：{{ getTaskTypeName(item.wtId) || "其他" }}
          </div> -->
          <div class="text-left" style="width: 80%">
            内容：{{ item.seqNum }}、<span v-html="item.content"></span>
          </div>
        </div>
      </div>

      <div v-if="workDetailInfo._currentTab == 'workDetailTask'">
        <work-detail-task ref="workDetailTask"></work-detail-task>
      </div>
      <div v-if="workDetailInfo._currentTab == 'workDetailTaskItem'">
        <work-detail-task-item ref="workDetailTaskItem"></work-detail-task-item>
      </div>
      <div v-if="workDetailInfo._currentTab == 'workDetailCopy'">
        <work-detail-copy ref="workDetailCopy"></work-detail-copy>
      </div>
      <div v-if="workDetailInfo._currentTab == 'workDetailEvent'">
        <work-detail-event ref="workDetailEvent"></work-detail-event>
      </div>
      <div v-if="workDetailInfo._currentTab == 'workDetailFile'">
        <work-detail-file ref="workDetailFile"></work-detail-file>
      </div>
      <div v-if="workDetailInfo._currentTab == 'workDetailType'">
        <work-detail-type ref="workDetailType"></work-detail-type>
      </div>
      <div v-if="workDetailInfo._currentTab == 'workDetailCycle'">
        <work-detail-cycle ref="workDetailCycle"></work-detail-cycle>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getWorkPoolDetail } from "@/api/oa/workDetailApi";
// 导入获取工作单类型字典的接口
import { listWorkType } from "@/api/oa/editWorkApi";
import WorkDetailTask from "@/components/oa/WorkDetailTask";
import WorkDetailTaskItem from "@/components/oa/WorkDetailTaskItem";
import WorkDetailCopy from "@/components/oa/WorkDetailCopy";
import WorkDetailEvent from "@/components/oa/WorkDetailEvent";
import WorkDetailFile from "@/components/oa/WorkDetailFile";
import WorkDetailType from "@/components/oa/WorkDetailType";
import WorkDetailCycle from "@/components/oa/WorkDetailCycle";
import Divider from "@/components/system/divider";
import { getCommunityId } from "@/api/community/communityApi";
export default {
  name: "WorkDetailList",
  components: {
    WorkDetailTask,
    WorkDetailTaskItem,
    WorkDetailCopy,
    WorkDetailEvent,
    WorkDetailFile,
    WorkDetailType,
    WorkDetailCycle,
    Divider,
  },
  data() {
    return {
      workDetailInfo: {
        viewWorkFlag: "",
        workId: "",
        wtId: "", // 任务类型字典ID
        workName: "",
        typeName: "", // 工作单类型名称
        workCycle: "",
        startTime: "",
        endTime: "",
        createUserName: "",
        curStaffName: "",
        curCopyName: "",
        stateName: "",
        createTime: "",
        content: "",
        pathUrls: [],
        _currentTab: "workDetailContent",
        contents: [],
        logType: "",
        problemsEncountered: "",
        workPlan: "",
      },
      workTypes: [], // 存储工作单类型字典数据
      communityId: "", // 社区ID
    };
  },
  computed: {
    standardPathUrls() {
      const pathUrls = this.workDetailInfo.pathUrls;
      if (!pathUrls || pathUrls.trim() === "") {
        return [];
      }
      if (Array.isArray(pathUrls)) {
        return pathUrls.filter((url) => url && url.trim());
      }
      return [pathUrls.trim()];
    },
  },
  created() {
    // 1. 获取社区ID
    this.communityId = getCommunityId();
    // 2. 获取工作单ID
    this.workDetailInfo.workId = this.$route.query.workId;
    if (!this.workDetailInfo.workId) {
      return;
    }
    // 3. 设置默认标签页
    const currentTab = this.$route.query.currentTab;
    if (currentTab) {
      this.workDetailInfo._currentTab = currentTab;
    }
    // 4. 先获取字典数据，再加载工作单详情
    this._listWorkTypes().then(() => {
      this.loadWorkInfo();
      this.changeTab(this.workDetailInfo._currentTab);
    });
  },
  methods: {
    // 获取工作单类型字典数据
    async _listWorkTypes() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId,
        };
        const res = await listWorkType(params);
        // 确认赋值正确的字典数组（res.data是返回的类型列表）
        this.workTypes = res.data || [];
        console.log("字典数据已加载:", this.workTypes);
      } catch (error) {
        console.error("获取工作单类型失败:", error);
        this.$message.warning("获取工作单类型失败");
      }
    },
    // 加载工作单详情
    async loadWorkInfo() {
      try {
        const params = {
          workId: this.workDetailInfo.workId,
          page: 1,
          row: 1,
        };
        const { data } = await getWorkPoolDetail(params);
        // 合并数据，确保wtId正确赋值
        this.workDetailInfo = { ...this.workDetailInfo, ...(data[0] || {}) };
        console.log("工作单详情（含wtId）:", this.workDetailInfo.wtId);
      } catch (error) {
        console.error("获取工作单详情失败:", error);
      }
    },
    // 切换标签页
    changeTab(tab) {
      this.workDetailInfo._currentTab = tab;
      setTimeout(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].open({
            taskId: this.workDetailInfo.taskId,
            workId: this.workDetailInfo.workId,
            wtId: this.workDetailInfo.wtId,
            contents: this.workDetailInfo.contents,
          });
        }
      }, 500);
    },
    // 根据wtId匹配获取任务类型名称 - 核心修复：统一数据类型进行匹配
    getTaskTypeName(wtId) {
      // 1. 边界判断：wtId为空或字典为空，直接返回空
      if (!wtId || this.workTypes.length === 0) {
        console.log("wtId为空或字典数据为空");
        return "";
      }
      // 2. 核心修复：将wtId和字典中的wtId统一转为字符串，避免类型不匹配导致匹配失败
      const targetWtId = String(wtId);
      const targetType = this.workTypes.find((item) => {
        // 字典中的wtId也转为字符串，确保全量匹配
        return String(item.wtId) === targetWtId;
      });
      // 3. 找到则返回typeName，否则返回空
      const typeName = targetType ? targetType.typeName : "";
      console.log("匹配到的任务类型:", typeName);
      return typeName;
    },
    // 查看图片附件
    // 下载文件（兼容图片/普通文件）
    viewTaskFileImg(url) {
      try {
        // 直接使用返回的文件地址下载，不调用后端接口
        if (!url) {
          this.$message.error("文件地址不存在，无法下载");
          return;
        }

        // 创建a标签实现下载
        const link = document.createElement("a");
        // 处理跨域/OSS文件下载
        link.href = url;
        link.target = "_blank"; // 新开窗口下载（兼容部分浏览器）

        // 解决某些浏览器不触发点击的问题
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success("文件下载已开始");
      } catch (error) {
        console.error("文件下载失败：", error);
        this.$message.error("文件下载失败，请重试");
      }
    },

    // 辅助方法：从URL中提取文件名
    extractFileNameFromUrl(url) {
      // 情况1：URL包含文件名（有后缀）
      if (url.lastIndexOf("/") > -1) {
        const fileName = url.substring(url.lastIndexOf("/") + 1);
        // 有后缀则直接返回
        if (fileName.includes(".")) {
          return fileName;
        }
      }
      // 情况2：无文件名，生成时间戳文件名（保留后缀）
      const ext = url.includes(".")
        ? url.substring(url.lastIndexOf("."))
        : ".file";
      return `下载文件_${Date.now()}${ext}`;
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.work-detail-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .text-title {
    font-size: 18px;
    font-weight: bold;
  }

  .margin-top {
    margin-top: 20px;
  }

  .margin-top-sm {
    margin-top: 10px;
  }

  .padding {
    padding: 10px;
  }

  .border-radius {
    border-radius: 4px;
  }

  .flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
  }

  .justify-start {
    justify-content: flex-start;
  }

  .form-group {
    margin-bottom: 15px;

    .col-form-label {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .mr-2 {
    margin-right: 8px;
  }
  .font-bold {
    font-weight: 600;
  }
}
</style>
